import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth0 } from '@auth0/auth0-react';
import { Icon, Menu, Portal, Text } from '@chakra-ui/react';
import { NavMenuContent, NavMenuItem, } from '@client/components/misc/NavMenu';
import { NavbarButton } from '@client/components/navbar/Navbar';
import { CLIENT_ROUTES } from '@client/constants';
import { useUserInfo } from '@client/providers/UserProvider';
import { FaHeart, FaUserCircle } from 'react-icons/fa';
import { FaArrowRightFromBracket, FaCaretDown, FaCrown, FaScroll, FaShop, } from 'react-icons/fa6';
import { Link } from 'react-router-dom';
export const NavbarMenu = () => {
    const { logout } = useAuth0();
    const { user } = useUserInfo();
    const handleLogout = async () => {
        logout({
            logoutParams: {
                returnTo: window.location.origin,
            },
        });
    };
    return (_jsxs(Menu.Root, { size: "md", children: [_jsx(Menu.Trigger, { asChild: true, focusRing: "none", children: _jsxs(NavbarButton, { pr: 1, pl: 2, py: 1, gap: 2, children: [_jsx(FaUserCircle, {}), _jsx(Icon, { as: FaCaretDown, w: 5, h: 5 })] }) }), _jsx(Portal, { children: _jsx(Menu.Positioner, { children: _jsxs(NavMenuContent, { width: 150, children: [_jsx(Link, { to: `/${CLIENT_ROUTES.favorites}`, children: _jsxs(NavMenuItem, { value: "saved", children: [_jsx(FaHeart, {}), _jsx(Text, { children: "Favorites" })] }) }), _jsx(Link, { to: `/${CLIENT_ROUTES.orders}`, children: _jsxs(NavMenuItem, { value: "orders", children: [_jsx(FaScroll, {}), _jsx(Text, { children: "Orders" })] }) }), !user?.isAdmin && user?.shopShortId && (_jsx(Link, { to: [
                                    CLIENT_ROUTES.shop,
                                    user.shopShortId,
                                    CLIENT_ROUTES.manage,
                                    CLIENT_ROUTES.info,
                                ].join('/'), children: _jsxs(NavMenuItem, { value: "shop", children: [_jsx(FaShop, {}), _jsx(Text, { children: "My Shop" })] }) })), user?.isAdmin && (_jsx(Link, { to: [
                                    CLIENT_ROUTES.admin,
                                    CLIENT_ROUTES.shops,
                                ].join('/'), children: _jsxs(NavMenuItem, { value: "admin", children: [_jsx(FaCrown, {}), _jsx(Text, { children: "Admin" })] }) })), _jsxs(NavMenuItem, { value: "logout", onClick: handleLogout, children: [_jsx(FaArrowRightFromBracket, {}), _jsx(Text, { children: "Log Out" })] })] }) }) })] }));
};
